import { useMemo } from "react";

import {

    Background,

    Controls,

    Node,

    ReactFlow,

    ReactFlowProvider

} from "@xyflow/react";

import "@xyflow/react/dist/style.css";



import styles from "./NoteWorkflows.module.css";

import { WorkflowNodeSelection } from "./noteWorkflowsTypes";

import { NoteWorkflowsDocument } from "./noteWorkflowsTypes";

import { WorkflowNode } from "./WorkflowNode";

import { WorkflowNodeData, workflowsToFlow } from "./workflowsToFlow";



const nodeTypes = {
    trigger: WorkflowNode,
    step: WorkflowNode,
    outcome: WorkflowNode,
    subflow: WorkflowNode,
    subflow_step: WorkflowNode
};



interface NoteWorkflowsCanvasProps {

    document: NoteWorkflowsDocument;

    selected: WorkflowNodeSelection | null;

    onNodeSelect: (selection: WorkflowNodeSelection) => void;

    variant?: "inline" | "fullscreen";

    activateOnKeyboard?: boolean;

}



function NoteWorkflowsCanvasInner({

    document,

    selected,

    onNodeSelect,

    variant = "inline",

    activateOnKeyboard = false

}: NoteWorkflowsCanvasProps) {

    const { nodes, edges } = useMemo(

        () => workflowsToFlow(document, selected),

        [document, selected]

    );



    const containerClass =

        variant === "fullscreen" ? styles.canvasContainerFullscreen : styles.canvasContainer;

    const selectNode = (node: Node<WorkflowNodeData>) => {
        const { workflowId, nodeKind, nodeId, subflowId } = node.data;
        if (nodeKind === "subflow_step" && subflowId) {
            onNodeSelect({
                workflowId,
                nodeKind: "subflow_step",
                subflowId,
                nodeId
            });
            return;
        }
        if (
            nodeKind === "trigger" ||
            nodeKind === "step" ||
            nodeKind === "outcome" ||
            nodeKind === "subflow"
        ) {
            onNodeSelect({ workflowId, nodeKind, nodeId });
        }
    };



    return (

        <div className={containerClass}>

            <ReactFlow

                nodes={nodes}

                edges={edges}

                nodeTypes={nodeTypes}

                nodesConnectable={false}

                edgesReconnectable={false}

                elementsSelectable

                minZoom={variant === "fullscreen" ? 0.1 : 0.5}

                fitView

                fitViewOptions={{ padding: 0.2 }}

                panOnScroll

                zoomOnScroll

                onNodeClick={(_event, node: Node<WorkflowNodeData>) => selectNode(node)}

                onKeyDownCapture={event => {
                    if (!activateOnKeyboard || (event.key !== "Enter" && event.key !== " ")) return;
                    const target = event.target;
                    if (!(target instanceof HTMLElement) || !target.classList.contains("react-flow__node")) return;
                    const node = nodes.find(item => item.id === target.dataset.id);
                    if (!node) return;
                    event.preventDefault();
                    event.stopPropagation();
                    selectNode(node);
                }}

                proOptions={{ hideAttribution: true }}

            >

                <Background gap={16} size={1} />

                <Controls showInteractive={false} />

            </ReactFlow>

        </div>

    );

}



export function NoteWorkflowsCanvas(props: NoteWorkflowsCanvasProps) {

    return (

        <ReactFlowProvider>

            <NoteWorkflowsCanvasInner {...props} />

        </ReactFlowProvider>

    );

}
